import { ref } from 'vue'

/**
 * A panel docked at the shell's inline end (the test call, 2026-10-12): its width on a wide screen,
 * 0 when none. The shell keeps the page's header and content clear of it (AppShell); the top bar
 * stays whole, the panel starting below it.
 */
export const dockWidth = ref(0)
